/* The notification-bell button for the TopNavigation utility (descriptor)  */
import { TopNavigationProps } from '@amzn/awsui-components-core';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import { isUnread } from './notificationModels';
import { useDismissedNotifications } from './useDismissedNotifications';

export const useNotificationBell = (onOpen: () => void): TopNavigationProps.Utility => {
  const items = useSelector((state: RootState) => state.notificationsStore.items);
  // Dismissed items must not count toward the badge, or the bell would advertise
  // notifications the user has already hidden.
  const { visibleItems } = useDismissedNotifications(items);
  const unreadCount = useMemo(() => visibleItems.filter(isUnread).length, [visibleItems]);

  return useMemo<TopNavigationProps.Utility>(
    () => ({
      type: 'button',
      iconName: 'notification',
      ariaLabel: 'Notifications',
      badge: unreadCount > 0,
      text: unreadCount > 0 ? String(unreadCount) : undefined,
      title: 'Notifications',
      // Opening the bell no longer marks everything read: that cleared the unread markers
      // before the user could see which rows were new. The panel advances the watermark when
      // it closes instead (see closePanel in NotificationPanel).
      onClick: onOpen
    }),
    [unreadCount, onOpen]
  );
};
